var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak4Lengeh9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,15.4H5.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5S7.6,15.4,7.3,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.7,14.9 6.9,11.4 6.9,18.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,15.3h-5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5S55,15.3,54.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V18C52.7,18.3,52.5,18.5,52.2,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,15.3h-5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5S25,15.3,24.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18C22.8,18.3,22.6,18.5,22.3,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,25.4H2.8V4.4h9.2V25.4z M3.8,24.4h7.3v-19H3.8V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3,15.4h-2.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5S37.5,15.4,37.3,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.6,14.9 36.9,11.4 36.9,18.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,25.4h-9.2V4.4H42V25.4z M33.8,24.4H41v-19h-7.3V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C30.1,29.8,29.9,30,29.6,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C45.3,29.8,45.1,30,44.8,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C15.3,29.8,15.1,30,14.8,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak4Lengeh9);
export default __webpack_public_path__ + "static/media/tak_4_lengeh_9.f022d704d3eee0afebca066dbe5f3f24.svg";
export { ForwardRef as ReactComponent };